"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CustomerCare() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  return <section data-section-id="4535" id="customercarecta" className="bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/fashion_studio_minimal.webp)]" />

      {}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(45, 68%, 98%, 0.95) 0%, hsla(0, 0%, 95%, 0.85) 50%, hsla(45, 68%, 98%, 0.9) 100%)"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-multiply" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative z-10 mx-auto flex max-w-[900px] flex-col items-center px-6 py-32 text-center md:py-44 lg:py-[180px]">
        {}
        <div ref={labelRef} className={`mb-12 transition-all duration-700 ease-out md:mb-16 ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-default text-xs tracking-[0.25em] text-accent uppercase font-medium">
            Service Excellence — Our Promise
          </span>
        </div>

        {}
        <h2 ref={headingRef} className={`font-default font-bold text-foreground leading-[1.1] tracking-tighter transition-all duration-1000 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        fontSize: "clamp(2.5rem, 8vw, 5.5rem)"
      }}>
          Excellence in every detail,
          <span className="block text-accent">dedicated to you.</span>
        </h2>

        {}
        <p ref={bodyRef} className={`mt-10 max-w-[640px] text-lg leading-relaxed text-foreground/80 transition-all duration-1000 delay-150 ease-out md:text-xl ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        fontFamily: "var(--font-sans)"
      }}>
          Experience personalized support tailored to your unique style needs. Our dedicated customer care team at Drip District is here to assist you with any questions, ensuring a seamless shopping journey from checkout to delivery.
        </p>

        {}
        <div ref={ctaRef} className={`mt-16 flex flex-col items-center gap-10 transition-all duration-1000 delay-300 ease-out sm:flex-row sm:gap-12 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="group h-auto rounded-lg bg-primary px-10 py-5 text-base font-semibold text-primary-foreground shadow-lg hover:bg-primary/90 hover:scale-105 transition-all duration-300">
            <Link to="#">
              Contact Support
              <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          <Link to="/ShopPage" className="group inline-flex items-center gap-2 border-b border-foreground/20 pb-1 text-sm font-semibold tracking-wide text-foreground/70 transition-all hover:border-accent hover:text-accent">
            Browse Collection
            <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>

        {}
        <p ref={captionRef} className={`mt-20 font-default text-[11px] tracking-[0.2em] text-foreground/50 uppercase transition-all duration-1000 delay-500 ease-out md:text-xs ${captionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Customer Excellence Hours — Monday to Friday, 08:00 - 18:00 EST
        </p>
      </div>
    </section>;
}